import { loadXMLText, setPoorlyWords, keepTwoDecimals } from './utils'
import { BASE_CONFIG } from '@/config'
// import locale from '@/locales/index'
/**
 * 解析屏显文本
 * @param {*} domWords 文本xmldom数组
 * @param {*} screenText 屏显文本
 * @param {*} is_rejected 是否乱读
 * @param {*} innerHtml 针对单音节评测，评测和屏显文本不一致，业务单独传参
 */
const buildScreenText = function (domWords, screenText, is_rejected, category, innerHtml) {
  if (!screenText) return ''
  let domText = new DOMParser().parseFromString(screenText, 'text/xml')
  let domFonts = domText.getElementsByTagName('font')
  const hasFont = !!domFonts.length
  let fontsArr = []
  if (!hasFont) {
    fontsArr = screenText.split(' ')
  }
  let total_score = 0 //总分
  let effectiveNum = 0 // 有效的字
  let tone1List = []
  let tone2List = []
  let tone3List = []
  let tone4List = []
  let isAdditionalAndback = false // 是否存在增读/回读的数据
  // let fontIndex = 0
  let evaluate_html = ''
  let i = 0 // 计数器
  let z = 0
  console.log('总的数组', domFonts)
  for (let windex = 0; windex < domFonts.length; windex++) {
    // console.log('每个数量', domFonts[windex])
    let reg =
      // eslint-disable-next-line no-useless-escape
      /[\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5|\a-zA-Z]/
    if (
      reg.test(domFonts[windex].textContent) ||
      !domFonts[windex].textContent ||
      domFonts[windex].textContent === ' '
    ) {
      // console.log('不合法的内容', domFonts[windex].textContent)
      continue
    }
    // console.log('合法的内容', typeof domFonts[windex].getAttribute('ignore'))
    let domWord = domWords[i]
    console.log('传过来的文本值', domWord)
    i++
    let fontColor = ''
    // 除去字词的
    if (is_rejected === 'true' && category !== 'read_word') {
      fontColor = '#838996'
      try {
        if (!hasFont) {
          if (fontsArr[windex]) {
            evaluate_html += '<font color="' + fontColor + '">' + fontsArr[windex] + '</font> '
          }
        } else {
          domFonts[windex].setAttribute('color', fontColor)
        }
      } catch {
        console.error('Build Evaluate Html Error')
      }
    } else {
      if (!domWord) {
        continue
      }
      const sylls = domWord.getElementsByTagName('syll')
      fontColor = '#eb5564'
      let j = z
      for (let index = 0; index < sylls.length; index++) {
        const syll = sylls[index]
        const phones = syll.getElementsByTagName('phone')
        if (phones.length >= 2) {
          if (
            syll.getAttribute('dp_message') !== '0' &&
            syll.getAttribute('dp_message') !== '128'
          ) {
            if (syll.getAttribute('dp_message') === '16') {
              fontColor = '#838996'
            } else {
              isAdditionalAndback = true
              continue
            }
          }
          let domYun = phones[0]
          let domSheng = phones[1]
          if (phones[0].getAttribute('is_yun') == '0') {
            domYun = phones[1]
            domSheng = phones[0]
          }

          // const score_standard = [100, 66, 33, 0]
          // const score_yun = score_standard[domYun.getAttribute('perr_msg')]
          // const score_sheng =
          //   score_standard[domSheng.getAttribute('perr_msg')]
          // const score_pinyin = (score_yun + score_sheng) / 2
          // const score_num =
          //   Number(domYun.getAttribute('perr_msg')) +
          //   Number(domSheng.getAttribute('perr_msg'))
          // const score_pinyin = parseInt(
          //   ((phones.length * 3 - score_num) / (phones.length * 3)) * 100
          // )
          effectiveNum++
          let yunScoreList = [75, 50, 25, 0]
          // let moneObj = {
          //   desc: domYun.getAttribute('mono_tone'),
          //   val:
          //     domYun.getAttribute('perr_msg') == 0 ||
          //     domYun.getAttribute('perr_msg') == 1
          //       ? 100
          //       : 0,
          // }
          let val =
            domYun.getAttribute('perr_msg') == 0 || domYun.getAttribute('perr_msg') == 1 ? 100 : 0
          switch (domYun.getAttribute('mono_tone')) {
            case 'TONE1':
              tone1List.push(val)
              break
            case 'TONE2':
              tone2List.push(val)
              break
            case 'TONE3':
              tone3List.push(val)
              break
            case 'TONE4':
              tone4List.push(val)
              break
          }
          const score_sheng = Number(domSheng.getAttribute('perr_msg')) ? 0 : 25
          const score_yun = yunScoreList[Number(domYun.getAttribute('perr_msg'))] || 0
          const score_pinyin = score_sheng + score_yun
          total_score += score_pinyin
          if (score_pinyin > BASE_CONFIG.excellent_score) {
            fontColor = '#09cba0'
          } else if (score_pinyin > BASE_CONFIG.standard_score) {
            fontColor = '#f9b718'
          } else {
            if (score_pinyin > 0) {
              fontColor = '#eb5564'
            } else {
              fontColor = '#838996'
            }
          }

          // let currFontIndex = fontIndex++
          try {
            if (!hasFont) {
              if (fontsArr[windex]) {
                evaluate_html += '<font color="' + fontColor + '">' + fontsArr[windex] + '</font> '
              }
              console.log('过滤掉的', windex, j, domFonts[windex + j])
            } else {
              console.log(windex, j, domFonts[windex + j])
              z = j
              domFonts[windex + j].setAttribute('color', fontColor)
              console.log(fontColor)
              j++
            }
          } catch {
            console.error('Build Evaluate Html Error')
          }
        }
      }
    }
  }
  if (hasFont) {
    evaluate_html = new XMLSerializer().serializeToString(domText)
  }
  total_score = effectiveNum ? total_score / effectiveNum : 0
  const arrAverageNum = (arr) => {
    var sum = eval(arr.join('+'))
    var result = sum / arr.length
    return ~~((result.toString().indexOf('.') > -1 ? result.toFixed(2) : result) * 100) / 100
  }
  let toneRateList = [
    arrAverageNum(tone1List),
    arrAverageNum(tone2List),
    arrAverageNum(tone3List),
    arrAverageNum(tone4List),
  ]
  // const compare = property => {
  //   return function(a, b) {
  //     var value1 = a[property]
  //     var value2 = b[property]
  //     return value1 - value2
  //   }
  // }
  // // 从大到小排序
  // toneRateList.sort(compare('val'))
  return (
    (evaluate_html || screenText) +
    '@@' +
    total_score +
    '@@' +
    isAdditionalAndback +
    '@@' +
    JSON.stringify(toneRateList)
  )
}

/**
 * 解析类型：read_sentence
 */
const buildReadSentenceResult = function ({ xml = '', text = '', category = '' } = {}) {
  let result = {
    accuracy_score: 0,
    fluency_score: 0,
    integrity_score: 0,
    total_score: 0,
    evaluate_html: '',
    study_report: '',
    evaluate_error_analysis: {}, //最终提交的数据结构
  }
  let study_report = {
    info: [],
    speed: 0,
    errorwords: [],
    leak: 0,
  }

  // 1. Base64 解码
  const binaryStr = atob(xml);

  // 2. 将二进制字符串转换为 Uint8Array
  const bytes = new Uint8Array(binaryStr.length);
  for (let i = 0; i < binaryStr.length; i++) {
    bytes[i] = binaryStr.charCodeAt(i);
  }

  // 3. 用 TextDecoder 解析 UTF-8
  let decodedStr = new TextDecoder('utf-8').decode(bytes);

  let xmlObj = loadXMLText(decodedStr)
    .getElementsByTagName('rec_paper')[0]
    .getElementsByTagName('read_sentence')[0]
  //准确度评分
  result.accuracy_score =
    keepTwoDecimals(xmlObj.getAttribute('phone_score')) +
    keepTwoDecimals(xmlObj.getAttribute('tone_score'))
  result.accuracy_score = keepTwoDecimals(result.accuracy_score / 2)
  //流畅度评分
  result.fluency_score = keepTwoDecimals(xmlObj.getAttribute('fluency_score'))
  //完整度评分
  result.integrity_score = keepTwoDecimals(xmlObj.getAttribute('integrity_score'))
  // 总分
  result.total_score = keepTwoDecimals(xmlObj.getAttribute('total_score'))
  console.log(result,'buildReadSentenceResult')
  const is_rejected = xmlObj.getAttribute('is_rejected')
  const except_info = xmlObj.getAttribute('except_info')
  let allWords = xmlObj.getElementsByTagName('word')
  // result.evaluate_html = buildScreenText(allWords, text, is_rejected ,category)
  result.evaluate_html = buildScreenText(allWords, text, is_rejected, category).split('@@')[0]
  // result.total_score = buildScreenText(allWords, text, is_rejected ,category).split('&')[1]
  result.isAdditionalAndback = buildScreenText(allWords, text, is_rejected, category).split('@@')[2]
  let toneAccuracyList = JSON.parse(
    buildScreenText(allWords, text, is_rejected, category).split('@@')[3]
  )

  result.is_rejected = is_rejected
  result.except_info = except_info
  // 学习报告
  let timelong = 0 // 朗读时长
  let lessCount = 0 // 漏读个数
  let speedCount = 0 // 平均朗读个数(分钟)
  let shengWrong = [] // 声母哪些读的不好
  let yunWrong = [] // 韵母哪些读的不好
  let toneWrong = [] // 声调哪些读的不好
  let domWords = allWords
  let domWordsLen = domWords.length
  for (let i = 0; i < domWordsLen; i++) {
    let domWord = domWords[i]
    const sylls = domWord.getElementsByTagName('syll')
    if (sylls.length > 0) {
      const syll = sylls[0]
      let start = Math.round(parseInt(domWord.getAttribute('beg_pos')) / 10)
      let end = Math.round(parseInt(domWord.getAttribute('end_pos')) / 10)
      if (syll.getAttribute('dp_message') == '16') {
        lessCount++
      } else {
        speedCount++

        if (end > timelong) {
          timelong = end
        }
      }
      // 算声韵母哪些读的不标准
      for (let index = 0; index < sylls.length; index++) {
        const syll = sylls[index]
        const phones = syll.getElementsByTagName('phone')
        if (phones.length >= 2 && syll.getAttribute('dp_message') !== '16') {
          // 漏读不算
          let domYun = phones[1]
          let domSheng = phones[0]

          const wrong_yunFlg = domYun.getAttribute('perr_msg')
          const wrong_shengFlg = domSheng.getAttribute('perr_msg')
          const wrong_yun =
            domYun && wrong_yunFlg !== '0' && wrong_yunFlg !== '2' && wrong_yunFlg !== '16'
          const wrong_sheng =
            domSheng && wrong_shengFlg !== '0' && wrong_shengFlg !== '2' && wrong_shengFlg !== '16'
          if (wrong_yun) {
            yunWrong.push(domYun.getAttribute('content'))
          }
          if (wrong_sheng && domSheng.getAttribute('perr_msg').indexOf('_') == -1) {
            shengWrong.push(domSheng.getAttribute('content'))
          }
          if (domSheng && wrong_yunFlg !== '0' && wrong_yunFlg !== '1' && wrong_yunFlg !== '16') {
            if (domYun.getAttribute('mono_tone')) {
              toneWrong.push(domYun.getAttribute('mono_tone').match(/[1-9][0-9]*/g)[0])
            }
          }
        }
      }
    }
  }

  // 朗读速度
  speedCount = parseInt((speedCount / (timelong / 10)) * 60)
  let feedback = []

  feedback.push({
    type: 'speed',
    value: is_rejected === 'true' ? 0 : speedCount,
  })

  // 漏读
  if (lessCount > 0) {
    feedback.push({
      type: 'miss',
      value: lessCount,
    })
  }

  study_report.shengWrong = Array.from(new Set(shengWrong))
  // 特殊处理韵母
  yunWrong.forEach((item, index) => {
    if (item.includes('ii')) {
      yunWrong[index] = 'i'
    } else if (item.includes('v')) {
      yunWrong[index] = item.replace('v', 'ü')
    }
  })
  //三端统一去除一下的零声母（_a,_i,_v,_u）
  const removeYunArr = ['_a', '_i', '_v', '_u']
  yunWrong.filter((item) => {
    return !removeYunArr.includes(item)
  })

  study_report.yunWrong = Array.from(new Set(yunWrong))
  let toneDesc = ['TONE1', 'TONE2', 'TONE3', 'TONE4']
  let toneWrongArray = []
  let errToneArr = [] // 统计声调低于60%
  Array.from(new Set(toneWrong)).forEach((item) => {
    toneWrongArray.push(`${toneDesc[Number(item) - 1]}`)
    if (toneAccuracyList[Number(item) - 1] < 60) {
      errToneArr.push(toneAccuracyList[Number(item) - 1])
    }
  })
  study_report.toneWrong = toneWrongArray

  let errorwords = buildPoorlyWords(domWords, is_rejected, true, true, errToneArr)

  let ai_analysis = []
  if (study_report.shengWrong.length > 0) {
    ai_analysis.push({
      type: 'sheng',
      item: study_report.shengWrong,
    })
  }
  if (study_report.yunWrong.length > 0) {
    ai_analysis.push({
      type: 'yun',
      item: study_report.yunWrong,
    })
  }
  if (study_report.toneWrong.length > 0) {
    ai_analysis.push({
      type: 'tone',
      item: study_report.toneWrong,
    })
  }
  ai_analysis.push({
    type: 'tone_accuracy',
    item: toneAccuracyList,
  })

  const getToneRate = (tone) => {
    if (!study_report.toneWrong) {
      return toneAccuracyList[tone - 1] || -1
    } else {
      return study_report.toneWrong.includes('TONE' + tone)
        ? toneAccuracyList[tone - 1]
        : toneAccuracyList[tone - 1] || -1
    }
  }
  //组装最终的数据结构
  result.evaluate_error_analysis = {
    error_words: errorwords,
    error_sm: study_report.shengWrong,
    error_ym: study_report.yunWrong,
    error_tone: study_report.toneWrong,
    tone1_correct_rate: getToneRate(1),
    tone2_correct_rate: getToneRate(2),
    tone3_correct_rate: getToneRate(3),
    tone4_correct_rate: getToneRate(4),
  }

  study_report = {
    ai_analysis,
    feedback,
    errorwords,
  }

  result.study_report = JSON.stringify(study_report)
  console.log('sentence===', result)
  console.log('===evaluate_error_analysis===', result.evaluate_error_analysis)

  return result
}

/**
 * 解析类型：read_word
 */
const buildReadWordResult = function ({ xml = '', text = '', category = '' } = {}) {
  let result = {
    accuracy_score: 0,
    fluency_score: 0,
    integrity_score: 0,
    total_score: 0,
    evaluate_html: '',
    study_report: '',
    evaluate_error_analysis: {}, //最终提交的数据结构
  }
  let study_report = {
    info: [],
    speed: 0,
    errorwords: [],
    leak: 0,
  }
  let xmlObj = loadXMLText(xml)
    .getElementsByTagName('rec_paper')[0]
    .getElementsByTagName('read_word')[0]
  // result.total_score = keepTwoDecimals(xmlObj.getAttribute('total_score'))
  const is_rejected = xmlObj.getAttribute('is_rejected')
  const except_info = xmlObj.getAttribute('except_info')
  // if (is_rejected === 'true') {
  //   result.total_score = keepTwoDecimals(result.total_score / 10)
  // }
  let allWords = xmlObj.getElementsByTagName('word')
  result.evaluate_html = buildScreenText(allWords, text, is_rejected, category).split('@@')[0]
  result.total_score = buildScreenText(allWords, text, is_rejected, category).split('@@')[1]
  let toneAccuracyList = JSON.parse(
    buildScreenText(allWords, text, is_rejected, category).split('@@')[3]
  )
  result.isAdditionalAndback = false
  result.is_rejected = is_rejected
  result.except_info = except_info

  // 学习报告
  let timelong = 0 // 朗读时长
  let lessCount = 0 // 漏读个数
  let speedCount = 0 // 平均朗读个数(分钟)
  let shengWrong = [] // 声母哪些读的不好
  let yunWrong = [] // 韵母哪些读的不好
  let toneWrong = [] // 声调哪些读的不好
  let domWords = allWords
  let domWordsLen = domWords.length
  for (let i = 0; i < domWordsLen; i++) {
    let domWord = domWords[i]
    const sylls = domWord.getElementsByTagName('syll')
    if (sylls.length > 0) {
      const syll = sylls[0]
      let start = Math.round(parseInt(domWord.getAttribute('beg_pos')) / 10)
      let end = Math.round(parseInt(domWord.getAttribute('end_pos')) / 10)
      if (syll.getAttribute('dp_message') == '16') {
        lessCount++
      } else {
        speedCount++

        if (end > timelong) {
          timelong = end
        }
      }
      // 算声韵母哪些读的不标准
      for (let index = 0; index < sylls.length; index++) {
        const syll = sylls[index]
        const phones = syll.getElementsByTagName('phone')
        if (phones.length >= 2 && syll.getAttribute('dp_message') !== '16') {
          // 漏读不算
          let domYun = phones[1]
          let domSheng = phones[0]

          const wrong_yunFlg = domYun.getAttribute('perr_msg')
          const wrong_shengFlg = domSheng.getAttribute('perr_msg')
          const wrong_yun =
            domYun && wrong_yunFlg !== '0' && wrong_yunFlg !== '2' && wrong_yunFlg !== '16'
          const wrong_sheng =
            domSheng && wrong_shengFlg !== '0' && wrong_shengFlg !== '2' && wrong_shengFlg !== '16'
          if (wrong_yun) {
            yunWrong.push(domYun.getAttribute('content'))
          }
          if (wrong_sheng && domSheng.getAttribute('perr_msg').indexOf('_') == -1) {
            shengWrong.push(domSheng.getAttribute('content'))
          }
          if (domSheng && wrong_yunFlg !== '0' && wrong_yunFlg !== '1' && wrong_yunFlg !== '16') {
            if (domYun.getAttribute('mono_tone')) {
              toneWrong.push(domYun.getAttribute('mono_tone').match(/[1-9][0-9]*/g)[0])
            }
          }
        }
      }
    }
  }

  // 朗读速度
  speedCount = parseInt((speedCount / (timelong / 10)) * 60)
  let feedback = []

  feedback.push({
    type: 'speed',
    value: is_rejected === 'true' ? 0 : speedCount,
  })

  // 漏读
  if (lessCount > 0) {
    feedback.push({
      type: 'miss',
      value: lessCount,
    })
  }

  study_report.shengWrong = Array.from(new Set(shengWrong))
  // 特殊处理韵母
  yunWrong.forEach((item, index) => {
    if (item.includes('ii')) {
      yunWrong[index] = 'i'
    } else if (item.includes('v')) {
      yunWrong[index] = item.replace('v', 'ü')
    }
  })
  //三端统一去除一下的零声母（_a,_i,_v,_u）
  const removeYunArr = ['_a', '_i', '_v', '_u']
  yunWrong.filter((item) => {
    return !removeYunArr.includes(item)
  })
  study_report.yunWrong = Array.from(new Set(yunWrong))
  let toneDesc = ['TONE1', 'TONE2', 'TONE3', 'TONE4']
  let toneWrongArray = []
  let errToneArr = [] // 统计声调低于60%
  Array.from(new Set(toneWrong)).forEach((item) => {
    toneWrongArray.push(`${toneDesc[Number(item) - 1]}`)
    if (toneAccuracyList[Number(item) - 1] < 60) {
      errToneArr.push(toneAccuracyList[Number(item) - 1])
    }
  })
  study_report.toneWrong = toneWrongArray

  let errorwords = buildPoorlyWords(domWords, is_rejected, true, true, errToneArr)

  let ai_analysis = []
  if (study_report.shengWrong.length > 0) {
    ai_analysis.push({
      type: 'sheng',
      item: study_report.shengWrong,
    })
  }
  if (study_report.yunWrong.length > 0) {
    ai_analysis.push({
      type: 'yun',
      item: study_report.yunWrong,
    })
  }
  if (study_report.toneWrong.length > 0) {
    ai_analysis.push({
      type: 'tone',
      item: study_report.toneWrong,
    })
  }
  ai_analysis.push({
    type: 'tone_accuracy',
    item: toneAccuracyList,
  })

  const getToneRate = (tone) => {
    if (!study_report.toneWrong) {
      return toneAccuracyList[tone - 1] || -1
    } else {
      return study_report.toneWrong.includes('TONE' + tone)
        ? toneAccuracyList[tone - 1]
        : toneAccuracyList[tone - 1] || -1
    }
  }

  //组装最终的数据结构
  result.evaluate_error_analysis = {
    error_words: errorwords,
    error_sm: study_report.shengWrong,
    error_ym: study_report.yunWrong,
    error_tone: study_report.toneWrong,
    tone1_correct_rate: getToneRate(1),
    tone2_correct_rate: getToneRate(2),
    tone3_correct_rate: getToneRate(3),
    tone4_correct_rate: getToneRate(4),
  }

  study_report = {
    ai_analysis,
    feedback,
    errorwords,
  }

  result.study_report = JSON.stringify(study_report)
  console.log('sentence===', result)
  console.log('===evaluate_error_analysis===', result.evaluate_error_analysis)

  return result
}
/**
 * 解析类型：read_syllable
 */
const buildReadSyllableResult = function ({
  xml = '',
  text = '',
  category = '',
  innerHtml = '',
} = {}) {
  let result = {
    accuracy_score: 0,
    fluency_score: 0,
    integrity_score: 0,
    total_score: 0,
    evaluate_html: '',
  }
  let xmlObj = loadXMLText(xml)
    .getElementsByTagName('rec_paper')[0]
    .getElementsByTagName('read_syllable')[0]
  result.total_score = keepTwoDecimals(xmlObj.getAttribute('total_score'))
  const is_rejected = xmlObj.getAttribute('is_rejected')
  const except_info = xmlObj.getAttribute('except_info')
  // if (is_rejected === 'true') {
  //   result.total_score = keepTwoDecimals(result.total_score / 10)
  // }
  let allWords = xmlObj.getElementsByTagName('word')
  result.evaluate_html = buildScreenText(allWords, text, is_rejected, category).split('@@')[0]
  //处理着色
  let fontColor = ''
  if (parseInt(result.total_score) > BASE_CONFIG.excellent_score) {
    fontColor = '#09cba0'
  } else if (parseInt(result.total_score) > BASE_CONFIG.standard_score) {
    fontColor = '#f9b718'
  } else {
    if (parseInt(result.total_score) > 0) {
      fontColor = '#eb5564'
    } else {
      fontColor = '#838996'
    }
  }
  // eslint-disable-next-line no-useless-escape
  let str = `<span><font color=\"${fontColor}\">${innerHtml}</font></span>`
  result.evaluate_html = str

  result.isAdditionalAndback = false
  result.is_rejected = is_rejected
  result.except_info = except_info

  return result
}
/**
 * 解析苦手单词
 * 百分制10~60 五分制0.5~3
 * @param {Array} domWords
 * @param {String} screenText
 * @param {Boolean} is_rejected
 * @param {Boolean} filterWhite 是否需要过滤白名单
 * @param {Boolean} isAllWrong 错字的统计维度：true-声调、声母、韵母错一个即为错字
 * @param {Boolean} errToneArr 统计声调低于60%
 * @returns {Array}
 */
const buildPoorlyWords = (domWords, is_rejected, filterWhite, isAllWrong, errToneArr) => {
  let errorwords = []
  const domWordsLen = domWords.length
  for (let i = 0; i < domWordsLen; i++) {
    let domWord = domWords[i]
    let word = domWord.getAttribute('content').trim().toLowerCase()
    const sylls = domWord.getElementsByTagName('syll')
    for (let index = 0; index < sylls.length; index++) {
      const syll = sylls[index]
      const phones = syll.getElementsByTagName('phone')
      if (phones.length >= 2 && syll.getAttribute('dp_message') !== '16') {
        // 漏读不算
        let domYun = phones[0]
        let domSheng = phones[1]
        if (phones[0].getAttribute('is_yun') == '0') {
          domYun = phones[1]
          domSheng = phones[0]
        }

        const right_yun = domYun && domYun.getAttribute('perr_msg') === '0'
        const right_sheng = domSheng && domSheng.getAttribute('perr_msg') === '0'
        const right_tone =
          phones[1].getAttribute('is_yun') == '1' &&
          errToneArr &&
          !errToneArr.includes(phones[1].getAttribute('mono_tone'))

        if (isAllWrong && (!right_yun || !right_sheng || !right_tone) && is_rejected !== 'true') {
          errorwords = setPoorlyWords(errorwords, word, filterWhite)
        }
        if (!isAllWrong && !right_yun && !right_sheng && is_rejected !== 'true') {
          errorwords = setPoorlyWords(errorwords, word, filterWhite)
        }
      }
    }
  }
  return errorwords
}
/**
 * 解析阅读结果
 * @param {XMLString} xml xml文本
 * @param {string} text 屏显文本
 */
const buildReadChapterResult = ({ xml = '', text = '', category = '' } = {}) => {
  let result = {
    total_score: null,
    accuracy_score: null, //准确度评分
    fluency_score: null, //流畅度评分
    integrity_score: null, //完整度评分
    study_report: '',
    evaluate_html: '',
  }
  let study_report = {
    info: [],
    speed: 0,
    errorwords: [],
    leak: 0,
  }
  //let decodedStr = atob(xml);

  // 1. Base64 解码
  const binaryStr = atob(xml);

  // 2. 将二进制字符串转换为 Uint8Array
  const bytes = new Uint8Array(binaryStr.length);
  for (let i = 0; i < binaryStr.length; i++) {
    bytes[i] = binaryStr.charCodeAt(i);
  }

  // 3. 用 TextDecoder 解析 UTF-8
  let decodedStr = new TextDecoder('utf-8').decode(bytes);

  // console.log(decodedStr);
  // // 2. 使用 DOMParser 解析为 XML
  // const parser = new DOMParser();
  // const xmlDoc = parser.parseFromString(decodedStr, 'application/xml');
  //
  // return false;
  let xmlObj = loadXMLText(decodedStr)
    .getElementsByTagName('rec_paper')[0]
    .getElementsByTagName('read_chapter')[0]
  result.accuracy_score =
    keepTwoDecimals(xmlObj.getAttribute('phone_score')) +
    keepTwoDecimals(xmlObj.getAttribute('tone_score'))
  result.accuracy_score = keepTwoDecimals(result.accuracy_score / 2) // 准确度评分
  result.fluency_score = keepTwoDecimals(xmlObj.getAttribute('fluency_score')) //流畅度评分
  result.integrity_score = keepTwoDecimals(xmlObj.getAttribute('integrity_score')) //完整度评分
  result.total_score = keepTwoDecimals(xmlObj.getAttribute('total_score'))
  console.log(result,'buildReadChapterResult')
  const is_rejected = xmlObj.getAttribute('is_rejected')
  const except_info = xmlObj.getAttribute('except_info')
  // if (is_rejected === 'true') {
  //   result.total_score = keepTwoDecimals(result.total_score / 10)
  // }

  // 汉字处理
  let allWords = xmlObj.getElementsByTagName('word')
  // result.evaluate_html = buildScreenText(allWords, text, is_rejected ,category)
  result.evaluate_html = buildScreenText(allWords, text, is_rejected, category).split('@@')[0]
  // result.total_score = buildScreenText(allWords, text, is_rejected ,category).split('&')[1]
  result.isAdditionalAndback = buildScreenText(allWords, text, is_rejected, category).split('@@')[2]
  let toneAccuracyList = JSON.parse(
    buildScreenText(allWords, text, is_rejected, category).split('@@')[3]
  )
  result.is_rejected = is_rejected
  result.except_info = except_info

  // 学习报告
  let timelong = 0 // 朗读时长
  let lessCount = 0 // 漏读个数
  let speedCount = 0 // 平均朗读个数(分钟)
  let shengWrong = [] // 声母哪些读的不好
  let yunWrong = [] // 韵母哪些读的不好
  let toneWrong = [] // 声调哪些读的不好
  let domWords = allWords
  let domWordsLen = domWords.length
  for (let i = 0; i < domWordsLen; i++) {
    let domWord = domWords[i]
    const sylls = domWord.getElementsByTagName('syll')
    if (sylls.length > 0) {
      const syll = sylls[0]
      let start = Math.round(parseInt(domWord.getAttribute('beg_pos')) / 10)
      let end = Math.round(parseInt(domWord.getAttribute('end_pos')) / 10)
      if (syll.getAttribute('dp_message') == '16') {
        lessCount++
      } else {
        speedCount++

        if (end > timelong) {
          timelong = end
        }
      }
      // 算声韵母哪些读的不标准
      for (let index = 0; index < sylls.length; index++) {
        const syll = sylls[index]
        const phones = syll.getElementsByTagName('phone')
        if (phones.length >= 2 && syll.getAttribute('dp_message') !== '16') {
          // 漏读不算
          let domYun = phones[1]
          let domSheng = phones[0]
          // if (phones[0].getAttribute('is_yun') == '0') {
          //   domYun = phones[1]
          //   domSheng = phones[0]
          // }
          const wrong_yunFlg = domYun.getAttribute('perr_msg')
          const wrong_shengFlg = domSheng.getAttribute('perr_msg')
          const wrong_yun =
            domYun && wrong_yunFlg !== '0' && wrong_yunFlg !== '2' && wrong_yunFlg !== '16'
          const wrong_sheng =
            domSheng && wrong_shengFlg !== '0' && wrong_shengFlg !== '2' && wrong_shengFlg !== '16'
          if (wrong_yun) {
            yunWrong.push(domYun.getAttribute('content'))
          }
          if (wrong_sheng && domSheng.getAttribute('perr_msg').indexOf('_') == -1) {
            shengWrong.push(domSheng.getAttribute('content'))
          }
          if (domSheng && wrong_yunFlg !== '0' && wrong_yunFlg !== '1' && wrong_yunFlg !== '16') {
            if (domYun.getAttribute('mono_tone')) {
              toneWrong.push(domYun.getAttribute('mono_tone').match(/[1-9][0-9]*/g)[0])
            }
          }
        }
      }
    }
  }

  // 朗读速度
  speedCount = parseInt((speedCount / (timelong / 10)) * 60)
  // study_report.speed = is_rejected === 'true' ? 0 : speedCount
  let feedback = []
  // if (is_rejected !== 'true') {

  feedback.push({
    type: 'speed',
    value: is_rejected === 'true' ? 0 : speedCount,
  })
  // if (speedCount > 180) {
  //   study_report.info.push(
  //     locale.t('result_report_speed_text1')+`${speedCount.toFixed(1)}`+locale.t('result_report_speed_text2')
  //   )
  // } else if (speedCount < 120) {
  //   study_report.info.push(
  //     locale.t('result_report_speed_text1')+`${speedCount.toFixed(1)}`+locale.t('result_report_speed_text3')
  //   )
  // }

  // }

  // 漏读
  if (lessCount > 0) {
    // study_report.leak = lessCount
    // study_report.info.push(locale.t('result_report_miss_read_text1')+`${lessCount}`+locale.t('result_report_miss_read_text2'))
    feedback.push({
      type: 'miss',
      value: lessCount,
    })
  }
  let errorwords = buildPoorlyWords(domWords, is_rejected, true)
  // android跟ios闪退,暂时单独处理
  // study_report.errorwords = study_report.errorwords.join('|')
  study_report.shengWrong = Array.from(new Set(shengWrong))
  // 特殊处理韵母
  yunWrong.forEach((item, index) => {
    if (item.includes('ii')) {
      yunWrong[index] = 'i'
    } else if (item.includes('v')) {
      yunWrong[index] = item.replace('v', 'ü')
    }
  })
  study_report.yunWrong = Array.from(new Set(yunWrong))
  // let toneDesc = [locale.t('result_report_tone1'), locale.t('result_report_tone2'), locale.t('result_report_tone3'), locale.t('result_report_tone4')]
  let toneDesc = ['TONE1', 'TONE2', 'TONE3', 'TONE4']
  let toneWrongArray = []
  Array.from(new Set(toneWrong)).forEach((item) => {
    toneWrongArray.push(`${toneDesc[Number(item) - 1]}`)
  })
  study_report.toneWrong = toneWrongArray

  // 统一app端报告数据结构
  // let feedback_string = ''
  // study_report.info.forEach((item, index) => {
  //   feedback_string += index + 1 + '）' + item + '\n'
  // })
  let ai_analysis = []
  if (study_report.shengWrong.length > 0) {
    ai_analysis.push(
      // locale.t('result_report_sheng_text1') + study_report.shengWrong.join('、') + locale.t('result_report_read_wrong')
      {
        type: 'sheng',
        item: study_report.shengWrong,
      }
    )
  }
  if (study_report.yunWrong.length > 0) {
    ai_analysis.push(
      // locale.t('result_report_yun_text1') + study_report.yunWrong.join('、') + locale.t('result_report_read_wrong')
      {
        type: 'yun',
        item: study_report.yunWrong,
      }
    )
  }
  if (study_report.toneWrong.length > 0) {
    ai_analysis.push(
      // locale.t('result_report_tone_text1') + study_report.toneWrong.join('、') + locale.t('result_report_read_wrong')
      {
        type: 'tone',
        item: study_report.toneWrong,
      }
    )
  }
  ai_analysis.push({
    type: 'tone_accuracy',
    item: toneAccuracyList,
  })
  // let ai_analysis_string = ''
  // ai_analysis.forEach((item, index) => {
  //   ai_analysis_string += index + 1 + '）' + item + '\n'
  // })
  study_report = {
    ai_analysis,
    feedback,
    errorwords,
  }

  result.study_report = JSON.stringify(study_report)
  // result.poorly_words = study_report.errorwords.join('|')

  return result
}

/**
 * 解析结果
 * category     评测类型
 * screen_text  屏显文本
 * xml          评测结果xml文本
 */
export const buildCnResult = ({ category, screen_text = '', xml, innerHtml }) => {
  if (!xml || !category) return {}
  let fn
  switch (category) {
    case 'read_word':
      fn = buildReadWordResult
      break
    case 'read_sentence':
      fn = buildReadSentenceResult
      break
    case 'read_chapter':
      fn = buildReadChapterResult
      break
    case 'read_syllable':
      fn = buildReadSyllableResult
      break
  }
  let result = fn({
    text: screen_text,
    xml: xml,
    category,
    innerHtml,
  })
  return result
}
